export default __webpack_public_path__ + "static/media/united-kingdom.ba1d3159.svg";